import axios from 'axios';
import { getAuthHeaders } from '../Auth';
import exportedConfig from '../config';

interface GeneratePatternParams {
    prompt: string;
    style?: string;
    signal: AbortSignal;
}

interface GeneratePatternResponse {
    imageUrl: string;
}

export const postGeneratePatternRequest = async ({
    prompt,
    style,
    signal,
}: GeneratePatternParams): Promise<GeneratePatternResponse> => {
    try {
        const headers = await getAuthHeaders();
        const response = await axios.post(
            `${exportedConfig.backendServiceUrl}/api/v3/inspiration:generatePattern`,
            {
                prompt,
                ...(style && { style }),
            },
            {
                signal,
                headers,
            },
        );

        if (!response.data) {
            throw new Error('Empty response from API');
        }

        if (!response.data.imageUrl) {
            console.error('API Response:', response.data);
            throw new Error('API response missing imageUrl field');
        }

        return {
            imageUrl: response.data.imageUrl,
        };
    } catch (error) {
        if (axios.isAxiosError(error)) {
            console.error('API Error:', error.response?.data || error.message);
            throw new Error(`API request failed: ${error.response?.data?.message || error.message}`);
        }
        console.error('Error generating pattern:', error);
        throw error;
    }
};
